import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

export default class NotAuthorized extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.NotAuthorized.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { className, message } = this.props;
        const containerClass = "container-fluid body-content not-authorized-container" + (className ? " " + className : "");
        const errorMsg = message ? message : "We’re sorry, but this page is not available to you.";

        return (
            <div className={containerClass}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="section-error-container">
                            <div className="row">
                                <div className="col-12 align-self-center">
                                    <div className="row section-error__header">
                                        <div className="col-12">
                                            <div className="section-error__header--title">
                                                <span className="icon-log-out" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row section-error__body">
                                        <div className="col-12">
                                            <div className="section-error__body--message">
                                                {errorMsg}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}